<div class="container">
  <div class="p-4 mb-3 rounded">
    <h4 class="font-weight-bold t-05rem title-datatable title-section"><i class="fa fa-list-alt"></i> Bandeja de tareas</h4>
    <div class="container table-responsive-md">
      <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display table row-border hover dataTable">
        <thead class="table-header">
          <tr class="text-uppercase">
            <th>Contrato</th>
            <th>Cupo</th>
            <th>Cliente</th>
            <th>Rol</th>
            <th>Fecha</th>
            <th>Estado</th>
            <th>Proceso</th>
            <th>Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor='let item of petitions'>
            <td>{{ item.contractNumber }}</td>
            <td>{{ item.quotaNumber }}</td>
            <td>{{ item.userName }}</td>
            <td>{{ item.role }}</td>
            <td>{{item.date | date: 'dd/MM/yyyy'}}</td>
            <td>{{status[item.status]}}</td>
            <td>{{ item.process }}</td>
            <td>
              <div class='row w-100 m-0 justify-content-center'>
                <div class='col-12'>
                  <button mat-flat-button class='btn-fixed-alt button-bg-blue' (click)="continueProcess(item)" [disabled]="cantContinue(item)">Continuar</button>
                </div>
              </div>
              <div class='row w-100 m-0 justify-content-center'>
                <div class='col-12'>
                  <button mat-flat-button class='btn-fixed-alt button-bg-gray' (click)="goTo('seguimiento', item)" *ngIf="showMonitoring(item)">Seguimiento</button>
                </div>
              </div>
              <div class='row w-100 m-0 justify-content-center'>
                <div class='col-12'>
                  <button mat-flat-button class='btn-fixed-alt button-bg-gray' (click)="goTo('cita', item)" *ngIf="showAppointment(item)">Cita</button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody *ngIf='!petitionsControl'>
          <tr>
              <td colspan="8" class="no-data-available">No se encontraron resultados</td>
          </tr>
      </tbody>
      </table>
      <ngx-spinner color="#c2af85" size="medium" type="ball-fussion">
        <p class='color-spinner-text'>Cargando... </p>
      </ngx-spinner>
    </div>
  </div>
</div>
